import React, { useCallback, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { useNavigate, useParams } from 'react-router-dom';
import classNames from 'classnames';
import Button from 'carbon-react/lib/components/button';

import { QUERY_PARAMS, ROUTES, getPredictPredictionsPageUrl } from '@futrli/shared-services';

import { OnboardingPageTitle } from '../components/onboarding-page-title';
import * as styles from '../forecasting-onboarding.scss';
import { OnboardingPredictionsRouter } from '../components/onboarding-predictions-router';
import readyToGo from '../arrows/ready-to-go.png';
import { useAnimationLatency } from '../utils/hooks';
import { HELP_MENU_EVENTS, useHelpMenuContext } from '../../../../../skeleton/src/help/HelpMenuContext/HelpMenuContext';
import { usePredictionsInfoContext } from '../../detail/context/predictions-info-context';

export const OnboardingReadyToGo = () => {
  const { workspaceId: tempWorkspaceId, organisationId: tempOrganisatioId } = useParams();
  const workspaceId = tempWorkspaceId || '';
  const organisationId = tempOrganisatioId || '';
  const { forecast } = usePredictionsInfoContext();

  const { openMenu } = useHelpMenuContext();

  const navigate = useNavigate();

  const showAnimatedArrow = useAnimationLatency(true);

  useEffect(() => {
    openMenu();
  }, [openMenu]);

  const handleNextClick = useCallback(() => {
    if (!forecast) {
      return;
    }

    navigate(
      `${getPredictPredictionsPageUrl(workspaceId, organisationId, forecast.id)}${ROUTES.SALES}?${
        QUERY_PARAMS.ONBOARDING_COMPLETE
      }=true`
    );
  }, [forecast, navigate, organisationId, workspaceId]);

  // listen for help menu close and advance
  useEffect(() => {
    window.addEventListener(HELP_MENU_EVENTS.close, handleNextClick);
    return () => {
      window.removeEventListener(HELP_MENU_EVENTS.close, handleNextClick);
    };
  }, [handleNextClick]);

  return (
    <div className={styles.contentContainer} style={{ position: 'relative' }}>
      <img
        alt="onboarding-arrow"
        src={readyToGo}
        style={{ position: 'absolute', right: 250, top: 0 }}
        className={classNames(styles.fadeInContainer, {
          [styles.fadeIn]: showAnimatedArrow
        })}
      />
      <OnboardingPageTitle
        title={
          <FormattedMessage
            id="onboarding.you_are_ready_to_go"
            defaultMessage="You’re ready to go! Learn more with our help section..."
          />
        }
        description={
          <FormattedMessage id="onboarding.start_with_futrli_now" defaultMessage="Get started with Futrli now!" />
        }
      />
      <Button mb="30px" buttonType="primary" size="large" onClick={handleNextClick}>
        <FormattedMessage id="common.next" defaultMessage="Next" />
      </Button>
      <OnboardingPredictionsRouter />
    </div>
  );
};
